import TextEditor from "../../common/TextEditor"

const Cookies = () => {
  return (
    <div className="main-content">
      <div className="container-fluid">
        <div className='d-flex justify-content-between'>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link active`}
              >
                Cookies
              </button>
            </li>


          </ul>
        </div>
        <TextEditor type={"cookies"} />
      </div>


    </div>
  )
}

export default Cookies